import Room from './components/Room';

export default Room;
